import React from "react"
import { Container } from "./container"

export interface ToolbarProps {
    children?: any
}

export class Toolbar extends React.Component<ToolbarProps, any> {
    private rootDiv: any

    updateRootDiv = (e: any) => {
        this.rootDiv = e
    }

    componentDidMount() {
        window.addEventListener("scroll", () => {
            if (!this.rootDiv) {
                return
            }

            if (window.scrollY === 0) {
                this.rootDiv.classList.remove("scrolling")
            } else {
                this.rootDiv.classList.add("scrolling")
            }
        })
    }

    render() {
        return (
            <div className="toolbar" ref={this.updateRootDiv}>
                <Container>{this.props.children}</Container>
            </div>
        )
    }
}
